module.exports = __webpack_public_path__ + "img/paper_fail.3526062c.svg";